/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetSavedItemsOutfitsQueryVariables = Types.Exact<{
  numOutfits: Types.Scalars["Int"]["input"];
}>;

export type GetSavedItemsOutfitsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    savedItemsCollection: {
      __typename?: "SavedItemsCollection";
      outfits: {
        __typename?: "OutfitConnection";
        nodes: Array<{
          __typename?: "Outfit";
          id: string;
          items: Array<{
            __typename?: "OutfitItem";
            sticker?: {
              __typename?: "ModeStickerLabel";
              label: string;
              theme: Types.ModeStickerLabelTheme;
            } | null;
            laydown: {
              __typename?: "OutfitItemLaydown";
              maxHeight: number;
              maxWidth: number;
              x: number;
              y: number;
              xAnchor: string;
              yAnchor: string;
            };
            shopProductVariant?: {
              __typename?: "ShopProductVariant";
              sku: string;
              url: string;
              image?: {
                __typename?: "ShopMedia";
                id: string;
                altText: string;
                imageUrl: string;
              } | null;
            } | null;
          }>;
        }>;
      };
    };
  } | null;
};

export type SavedItemsOutfitFragment = {
  __typename?: "Outfit";
  id: string;
  items: Array<{
    __typename?: "OutfitItem";
    sticker?: {
      __typename?: "ModeStickerLabel";
      label: string;
      theme: Types.ModeStickerLabelTheme;
    } | null;
    laydown: {
      __typename?: "OutfitItemLaydown";
      maxHeight: number;
      maxWidth: number;
      x: number;
      y: number;
      xAnchor: string;
      yAnchor: string;
    };
    shopProductVariant?: {
      __typename?: "ShopProductVariant";
      sku: string;
      url: string;
      image?: { __typename?: "ShopMedia"; id: string; altText: string; imageUrl: string } | null;
    } | null;
  }>;
};

export type SavedItemOutfitItemFragment = {
  __typename?: "OutfitItem";
  sticker?: {
    __typename?: "ModeStickerLabel";
    label: string;
    theme: Types.ModeStickerLabelTheme;
  } | null;
  laydown: {
    __typename?: "OutfitItemLaydown";
    maxHeight: number;
    maxWidth: number;
    x: number;
    y: number;
    xAnchor: string;
    yAnchor: string;
  };
  shopProductVariant?: {
    __typename?: "ShopProductVariant";
    sku: string;
    url: string;
    image?: { __typename?: "ShopMedia"; id: string; altText: string; imageUrl: string } | null;
  } | null;
};

export const SavedItemOutfitItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SavedItemOutfitItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OutfitItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sticker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "laydown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "maxHeight" } },
                { kind: "Field", name: { kind: "Name", value: "maxWidth" } },
                { kind: "Field", name: { kind: "Name", value: "x" } },
                { kind: "Field", name: { kind: "Name", value: "y" } },
                { kind: "Field", name: { kind: "Name", value: "xAnchor" } },
                { kind: "Field", name: { kind: "Name", value: "yAnchor" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductVariant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "imageUrl" },
                        name: { kind: "Name", value: "transformedSrc" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "options" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "sizePreset" },
                                  value: { kind: "EnumValue", value: "MEDIUM" },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "transformations" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      { kind: "EnumValue", value: "TRIM_EFFECT" },
                                      { kind: "EnumValue", value: "AUTO_FORMAT_QUALITY" },
                                      { kind: "EnumValue", value: "REPLACE_COLOR_FOR_SHOP" },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sku" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SavedItemsOutfitFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SavedItemsOutfit" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Outfit" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SavedItemOutfitItem" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SavedItemOutfitItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OutfitItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sticker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "laydown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "maxHeight" } },
                { kind: "Field", name: { kind: "Name", value: "maxWidth" } },
                { kind: "Field", name: { kind: "Name", value: "x" } },
                { kind: "Field", name: { kind: "Name", value: "y" } },
                { kind: "Field", name: { kind: "Name", value: "xAnchor" } },
                { kind: "Field", name: { kind: "Name", value: "yAnchor" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductVariant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "imageUrl" },
                        name: { kind: "Name", value: "transformedSrc" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "options" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "sizePreset" },
                                  value: { kind: "EnumValue", value: "MEDIUM" },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "transformations" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      { kind: "EnumValue", value: "TRIM_EFFECT" },
                                      { kind: "EnumValue", value: "AUTO_FORMAT_QUALITY" },
                                      { kind: "EnumValue", value: "REPLACE_COLOR_FOR_SHOP" },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sku" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetSavedItemsOutfitsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSavedItemsOutfits" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "numOutfits" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "savedItemsCollection" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outfits" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "numOutfits" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nodes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "SavedItemsOutfit" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SavedItemOutfitItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OutfitItem" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sticker" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "theme" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "laydown" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "maxHeight" } },
                { kind: "Field", name: { kind: "Name", value: "maxWidth" } },
                { kind: "Field", name: { kind: "Name", value: "x" } },
                { kind: "Field", name: { kind: "Name", value: "y" } },
                { kind: "Field", name: { kind: "Name", value: "xAnchor" } },
                { kind: "Field", name: { kind: "Name", value: "yAnchor" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductVariant" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "imageUrl" },
                        name: { kind: "Name", value: "transformedSrc" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "options" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "sizePreset" },
                                  value: { kind: "EnumValue", value: "MEDIUM" },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "transformations" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      { kind: "EnumValue", value: "TRIM_EFFECT" },
                                      { kind: "EnumValue", value: "AUTO_FORMAT_QUALITY" },
                                      { kind: "EnumValue", value: "REPLACE_COLOR_FOR_SHOP" },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "sku" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SavedItemsOutfit" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Outfit" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "FragmentSpread", name: { kind: "Name", value: "SavedItemOutfitItem" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSavedItemsOutfitsQuery__
 *
 * To run a query within a React component, call `useGetSavedItemsOutfitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedItemsOutfitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedItemsOutfitsQuery({
 *   variables: {
 *      numOutfits: // value for 'numOutfits'
 *   },
 * });
 */
export function useGetSavedItemsOutfitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSavedItemsOutfitsQuery,
    GetSavedItemsOutfitsQueryVariables
  > &
    ({ variables: GetSavedItemsOutfitsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSavedItemsOutfitsQuery, GetSavedItemsOutfitsQueryVariables>(
    GetSavedItemsOutfitsDocument,
    options,
  );
}
export function useGetSavedItemsOutfitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSavedItemsOutfitsQuery,
    GetSavedItemsOutfitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSavedItemsOutfitsQuery, GetSavedItemsOutfitsQueryVariables>(
    GetSavedItemsOutfitsDocument,
    options,
  );
}
// @ts-ignore
export function useGetSavedItemsOutfitsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSavedItemsOutfitsQuery,
    GetSavedItemsOutfitsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSavedItemsOutfitsQuery, GetSavedItemsOutfitsQueryVariables>;
export function useGetSavedItemsOutfitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSavedItemsOutfitsQuery,
        GetSavedItemsOutfitsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetSavedItemsOutfitsQuery | undefined,
  GetSavedItemsOutfitsQueryVariables
>;
export function useGetSavedItemsOutfitsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSavedItemsOutfitsQuery,
        GetSavedItemsOutfitsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSavedItemsOutfitsQuery, GetSavedItemsOutfitsQueryVariables>(
    GetSavedItemsOutfitsDocument,
    options,
  );
}
export type GetSavedItemsOutfitsQueryHookResult = ReturnType<typeof useGetSavedItemsOutfitsQuery>;
export type GetSavedItemsOutfitsLazyQueryHookResult = ReturnType<
  typeof useGetSavedItemsOutfitsLazyQuery
>;
export type GetSavedItemsOutfitsSuspenseQueryHookResult = ReturnType<
  typeof useGetSavedItemsOutfitsSuspenseQuery
>;
export type GetSavedItemsOutfitsQueryResult = Apollo.QueryResult<
  GetSavedItemsOutfitsQuery,
  GetSavedItemsOutfitsQueryVariables
>;
